import { AxiosResponse } from 'axios';

import { Invoice, InvoiceApiGetInvoicesRequest } from '@videoblocks/subscription-service-client';
import { LoggerFactory } from '@videoblocks/typescript-logger';

import { invoiceApi, subscriptionServiceConfig } from './subscriptionServiceConfig';

const logger = LoggerFactory.create('Subscription Service Client - Invoices Api');

const getInvoicesForUser = async (userId: number): Promise<Invoice[]> => {
    const request: InvoiceApiGetInvoicesRequest = {
        userId,
    };
    try {
        const result = await invoiceApi.getInvoices(request);
        return result.data;
    } catch (error) {
        logger.error({ userId, error }, `Error fetching Invoices for user ${userId}`);
        return [];
    }
};

const getInvoicePDF = async (invoiceId: string): Promise<Buffer | null> => {
    try {
        /* Using the generated client for this seems to corrupt the data somehow, unsure why. 
           If anyone else wants to take a crack at refactoring this to use the client, feel free! */
        const response = await fetch(
            `${subscriptionServiceConfig.basePath as string}/api/v1/invoices/${invoiceId}/pdf`,
        );

        const buffer = await response.arrayBuffer();
        const data = Buffer.from(buffer);

        return data ?? null;
    } catch (error) {
        logger.error({ invoiceId, error }, `Error fetching PDF for invoice ID ${invoiceId}`);
        return null;
    }
};

export const InvoiceApi = {
    getInvoicesForUser,
    getInvoicePDF,
};
